<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-row>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.videoAuditType"
          placeholder="审核类型"
        >
          <el-option
            v-for="(item, i) in auditTypeData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-cascader
          class="select_btn_style"
          v-model="filters.categoryId"
          placeholder="视频分类"
          :options="videoCategoryData"
          :props="{
            label: 'name',
            value: 'id',
            children: 'children',
            checkStrictly: true,
          }"
          clearable
        >
        </el-cascader>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.videoSource"
          placeholder="视频来源"
        >
          <el-option
            v-for="(item, i) in videoSourceData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.videoType"
          placeholder="视频类型"
        >
          <el-option
            v-for="(item, i) in videoTypeData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.sharedStatus"
          placeholder="共享状态"
        >
          <el-option
            v-for="(item, i) in sharedData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.onlineStatus"
          placeholder="上线状态"
        >
          <el-option
            v-for="(item, i) in onlineStatusData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.isRequired"
          placeholder="是否必修"
        >
          <el-option
            v-for="(item, i) in isRequiredData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn_140">
        <el-select
          class="select_btn_style"
          v-model="filters.displayClientTypes"
          placeholder="展示终端"
          multiple
          collapse-tags
        >
          <el-option
            v-for="(item, i) in clientTypeData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn_140">
        <el-select
          class="select_btn_style"
          v-model="filters.tagKeys"
          placeholder="视频标签"
          multiple
          collapse-tags
        >
          <el-option
            v-for="(item, i) in videoTagData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn_140">
        <el-select
          class="select_btn_style"
          v-model="filters.safeCheckStatus"
          placeholder="安全审查状态"
        >
          <el-option
            v-for="(item, i) in auditData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="select_btn_140">
        <el-select
          class="select_btn_style"
          v-model="filters.expireStatus"
          placeholder="视频有效期"
        >
          <el-option
            v-for="(item, i) in videoExpireStatus"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="m-l-14">
        <el-input
          prefix-icon="el-icon-search"
          size="small"
          v-model.trim="filters.name"
          placeholder="视频(集)名称/讲师姓名"
          @keyup.enter.native="initData"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          clearable
          prefix-icon="el-icon-search"
          size="small"
          v-model.trim="filters.videoId"
          placeholder="视频id"
          @keyup.enter.native="initData"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          clearable
          prefix-icon="el-icon-search"
          size="small"
          v-model.trim="filters.description"
          placeholder="视频简介"
          @keyup.enter.native="initData"
        ></el-input>
      </el-form-item>
      <el-form-item v-show="!showMore">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
        <butn
          title="展开"
          iconName="el-icon-arrow-down"
          @click="showMore = true"
          class="czButn"
        ></butn>
      </el-form-item>
    </el-row>
    <el-row v-show="showMore">
      <el-form-item label="有效期：">
        <el-date-picker
          class="date-picker"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          v-model="filters.expireTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="上线时间：">
        <el-date-picker
          class="date-picker"
          value-format="yyyy-MM-dd"
          size="small"
          v-model="filters.createTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
        <butn
          title="收起"
          iconName="el-icon-arrow-up"
          @click="showMore = false"
          class="czButn"
        ></butn>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import { resCategoryTree } from "@/api/rescategory";
import { getSysParamByTypes } from "@/api/sysParam";
import butn from "@/components/button/index";
import { getEnums } from "@/utils/common.js";
export default {
  components: { butn },
  data() {
    return {
      filters: {
        videoId: "",
        description: "",
      },
      options: [],
      auditTypeData: [],
      videoCategoryData: [],
      videoSourceData: [],
      videoTypeData: [],
      sharedData: [],
      onlineStatusData: [],
      isRequiredData: [],
      clientTypeData: [],
      videoTagData: [],
      auditData: [],
      videoExpireStatus: [],
      showMore: false,
      defaultProps: {
        children: "children",
        label: "name",
      },
      showName: "",
    };
  },
  created() {
    this.getSysParamByTypes();
    // 获取视频分类数据
    resCategoryTree({ categoryType: 0, display: 1 }).then((res) => {
      if (!res || res.code != 0) return;
      this.videoCategoryData = res.data;
    });
  },
  computed: {
    dropWidth() {
      return this.showMore ? 18 : 10;
    },
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes() {
      getEnums(
        [
          "ONLINE_STATUS",
          "VIDEO_AUDIT_TYPE",
          "VIDEO_SOURCE",
          "VIDEO_TYPE",
          "SHARED_SCREEN_STATUS",
          "IS_VALID",
          "DISPLAY_CLIENT_TYPE",
          "RECOMMEND_TAG",
          "SAFE_CHECK_STATUS",
          "VIDEO_EXPIRE_STATUS",
        ],
        this,
        [
          "onlineStatusData",
          "auditTypeData",
          "videoSourceData",
          "videoTypeData",
          "sharedData",
          "isRequiredData",
          "clientTypeData",
          "videoTagData",
          "auditData",
          "videoExpireStatus",
        ],
        [true, true, true, true, true, true, false, false, true, true]
      );
    },
    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([data]);
        this.filters.categoryId = data.id;
        this.showName = data.name;
      }
    },
    initData() {
      let params = Object.assign({}, this.filters);
      delete params.expireTime;
      delete params.createTime;
      if (this.filters.expireTime) {
        params["expireStartTime"] = this.filters.expireTime[0];
        params["expireEndTime"] = this.filters.expireTime[1];
      }
      if (this.filters.createTime) {
        params["onlineStartTime"] = this.filters.createTime[0];
        params["onlineEndTime"] = this.filters.createTime[1];
      }
      let category_id = this.filters.categoryId
        ? JSON.parse(JSON.stringify(this.filters.categoryId)).pop()
        : "";
      this.$emit("search", {
        ...params,
        t: new Date().getTime(),
        categoryId: category_id,
      });
    },
    resetData() {
      this.filters = {};
      this.showName = "";
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;
.serach-form {
  text-align: left;
  & /deep/ .none-margin-right {
    margin-right: 0;
  }
  & /deep/ .date-picker {
    width: 240px;
  }
}
.tree-content {
  max-height: 400px;
  overflow: auto;
}
.sel-button {
  cursor: pointer;
  width: 118px;
  height: 30px;
  text-align: center;
  background: #edf2f9;
  border-radius: 2px;
  border: 1px solid #d7dbe0;
}
</style>
